import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import cn from 'classnames';

import Input from '../../form/Input';
import SelectInput from '../../form/SelectInput';

import * as v from '../../../modules/validators';

import reactSelectTheme from '../../shared/ReactSelect-formSmall.module.postcss';
import locationStyles from './Location.module.postcss';
import styles from '../../../../stylesheets/public/components/Forms.module.postcss';

function LocationSubscribeForm({ handleSubmit, valid, submitting }) {

  const frequencyOptions = [
    { value: 'weekly', label: 'Weekly' },
    { value: 'daily', label: 'Daily' },
  ];

  return (
    <form
      onSubmit={handleSubmit}
      className={cn(styles.FlexForm, locationStyles.SubscribeForm)}
    >
      <div className='Fieldset'>
        <Field
          placeholder='Email address'
          name='email'
          required
          component={Input}
          type='email'
          validate={[v.required]}
        />

        <div className={cn(locationStyles.SubscribeForm_Row, 'FormRow')}>
          <Field
            name='frequency'
            component={SelectInput}
            valueKey='value'
            labelKey='label'
            searchable={false}
            options={frequencyOptions}
            defaultValue={frequencyOptions[0]}
            noFormRow
            theme={reactSelectTheme}
          />

          <button
            type='submit'
            className={cn(locationStyles.SubscribeForm_Submit, 'Button')}
            disabled={!valid || submitting}
          >
            <span className="icon icon-arrow-right" alt='Submit' />
          </button>
        </div>
      </div>
    </form>
  );
}

LocationSubscribeForm.propTypes = {
  handleSubmit: PropTypes.func,
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
};

export default reduxForm({ form: 'location_subscribe' })(LocationSubscribeForm);
